import { models } from "types/api/viewModels";
import { convertToTitleCase } from "./string";
import { UnavailableDataPlaceholderText } from "constants/text";

export const displayBillToInfo = (billToInfo: models["BillToViewModel"] | undefined) => {
	if (!billToInfo) return UnavailableDataPlaceholderText;
	const cityAndStateParts = [billToInfo.city, billToInfo.state].filter(Boolean);
	const cityAndState = cityAndStateParts.length ? cityAndStateParts.join(", ") : undefined;
	const logisticsMode = billToInfo.logisticsMode ? convertToTitleCase(billToInfo.logisticsMode) : undefined;
	return [billToInfo.projectName, cityAndState, logisticsMode, billToInfo.billToId].filter(Boolean).join(" - ");
};

export const formatAccountName = (account?: models["CustomerAccountViewModel"] | null) => {
	if (!account?.accountNumber && !account?.accountName) return UnavailableDataPlaceholderText;
	return [account?.accountNumber, account?.accountName].filter(Boolean).join(" - ");
};
